import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Grid, TextField, Typography } from "@mui/material";
import EditNoteIcon from '@mui/icons-material/EditNote';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import BusinessIcon from '@mui/icons-material/Business';
import InfoIcon from '@mui/icons-material/Info';
import GGModalWindow from '../../../../UtilityComponents/GGModalWindow/GGModalWindow';
import pageTextConfig from "../../../../../assets/configs/Footer Config/textConfig";

interface ContactUsModalProps {
  open: boolean;
  tab: number;
  setTab: (tab: number) => void;
  formData: {
    fullName: string;
    contactNo: string;
    email: string;
    message: string;
  };
  onFormChange: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  onSubmit: () => void;
  onClose: () => void;
}

const ContactUsModal: React.FC<ContactUsModalProps> = ({
  open,
  tab,
  setTab,
  formData,
  onFormChange,
  onSubmit,
  onClose
}) => {
  const tab1TextConfig = pageTextConfig.footerTab1;
  const tab2TextConfig = pageTextConfig.footerTab2;

  const tab1Content = () => (
    <>
      <Grid item xs={12}>
        <TextField 
          label={tab1TextConfig.fullName.label} 
          name={tab1TextConfig.fullName.name} 
          variant="outlined" 
          style={{ width: '100%' }} 
          value={formData.fullName} 
          onChange={onFormChange} 
        />
      </Grid>
      <Grid item xs={6}>
        <TextField 
          label={tab1TextConfig.contactNo.label} 
          name={tab1TextConfig.contactNo.name} 
          variant="outlined" 
          style={{ width: '100%' }} 
          value={formData.contactNo} 
          onChange={onFormChange} 
        />
      </Grid>
      <Grid item xs={6}>
        <TextField 
          label={tab1TextConfig.email.label} 
          name={tab1TextConfig.email.name} 
          variant="outlined" 
          style={{ width: '100%' }} 
          value={formData.email} 
          onChange={onFormChange} 
        />
      </Grid>
      <Grid item xs={12} className="footer-message">
        <TextField
          label={tab1TextConfig.message.label}
          name={tab1TextConfig.message.name}
          variant="outlined"
          helperText={
            <Box className="description-footer">
              <Box className="helper-text">
                <InfoIcon sx={{ marginRight: "10px" }} />
                <Box>
                  <i>{tab1TextConfig.message.helperText}</i>
                </Box>
              </Box>
              <Box>
                Message length: {formData.message.length}
              </Box>
            </Box>
          }
          value={formData.message}
          multiline
          rows={5}
          inputProps={{ maxLength: 4000 }}
          sx={{ marginBottom: '30px' }}
          fullWidth
          onChange={onFormChange}
        />
      </Grid>
      <Grid className="footerTabSubmitBtn" item xs={12}>
        <Link to="#" onClick={onSubmit}>Submit</Link>
      </Grid>
    </>
  );

  const tab2Content = () => (
    <>
      <Grid item xs={12} sm={3} display={"flex"} alignItems={"center"} fontSize={"12px"}>
        <CallIcon />
        <Typography marginLeft={"10px"} variant="h6" component="h2" textAlign={"left"} p={0}>
          {tab2TextConfig.contact.title}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={9}>
        <Typography variant="subtitle1" component="h2" textAlign={"left"}>
          {tab2TextConfig.contact.data}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={3} display={"flex"} alignItems={"center"}>
        <EmailIcon />
        <Typography marginLeft={"10px"} variant="h6" component="h2" textAlign={"left"}>
          {tab2TextConfig.email.title}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={9}>
        <Typography variant="subtitle1" component="h2" textAlign={"left"}>
          {tab2TextConfig.email.data}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={3} display={"flex"} alignItems={"center"}>
        <BusinessIcon />
        <Typography marginLeft={"10px"} variant="h6" component="h2" textAlign={"left"}>
          {tab2TextConfig.address.title}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={9}>
        <Typography variant="subtitle1" component="h2" textAlign={"left"}>
          {tab2TextConfig.address.data}
        </Typography>
      </Grid>
    </>
  );

  const modalContent = (
    <Grid container spacing={4}>
      <Grid item xs={6}>
        <div className={tab === 0 ? "footerTab active" : "footerTab"} onClick={() => setTab(0)}>
          <EditNoteIcon style={{ marginRight: "0.5rem" }} fontSize="inherit" />
          Write to Us
        </div>
      </Grid>
      <Grid item xs={6}>
        <div className={tab === 1 ? "footerTab active" : "footerTab"} onClick={() => setTab(1)}>
          <CallIcon style={{ marginRight: "0.5rem" }} fontSize="inherit" />
          Contact Us
        </div>
      </Grid>
      {tab === 0 ? tab1Content() : tab2Content()}
    </Grid>
  );

  return (
    <GGModalWindow
      childView={modalContent}
      open={open}
      onCloseHandler={onClose}
      title={"Contact Us"}
    />
  );
};

export default ContactUsModal;
